import { Alert, Box, Snackbar } from "@mui/material";
import React, {
  createContext,
  forwardRef,
  useCallback,
  useContext,
  useState,
} from "react";

type FeedbackType = {
  show: any;
  showBigText: any;
  type: FeedbackSeverity;
  arrFeedback: any[];
  message: string | React.ReactElement;
  setType: Function;
  setMessage: Function;
};

const feedbackContext = createContext<FeedbackType>(undefined!);

export const ProvideFeedback = ({ children }: any) => {
  const feedback: FeedbackType = useProvideFeedback();
  return (
    <feedbackContext.Provider value={feedback}>
      {children}
      {feedback.arrFeedback.map((item, index) => (
        <React.Fragment key={index}>{item}</React.Fragment>
      ))}
    </feedbackContext.Provider>
  );
};

export const useFeedback = () => {
  return useContext(feedbackContext);
};

type FeedbackSeverity = "success" | "info" | "warning" | "error";
const useProvideFeedback = () => {
  const [arrFeedback, setArrFeedback] = useState<any[]>([]);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<FeedbackSeverity>("info");

  const show = useCallback(
    (obj: {
      type: FeedbackSeverity;
      message: string | React.ReactElement | any;
    }) => {
      const arr: any[] = [...arrFeedback];
      arr.push(
        <Feedback
          type={obj.type}
          message={
            <Box>
              <span dangerouslySetInnerHTML={{ __html: obj.message }}></span>
            </Box>
          }
          isBig={false}
        />
      );
      setArrFeedback(arr);
    },
    [arrFeedback]
  );

  const showBigText = useCallback(
    (obj: { type: FeedbackSeverity; message: string | React.ReactElement }) => {
      const arr: any[] = [...arrFeedback];
      arr.push(
        <Feedback
          type={obj.type}
          message={<Box>{obj.message}</Box>}
          isBig={true}
        />
      );
      setArrFeedback(arr);
    },
    [arrFeedback]
  );

  return {
    arrFeedback,
    show,
    showBigText,
    type,
    message,
    setType,
    setMessage,
  };
};

type FeedbackProps = {
  type: FeedbackSeverity;
  message: string | React.ReactElement;
  isBig: boolean;
};
const Feedback = forwardRef(({ type, message, isBig }: FeedbackProps, ref) => {
  const [show, setShow] = useState(true);
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);
  };
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={show}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      {isBig ? (
        <Alert
          children={message}
          onClose={handleClose}
          severity={type}
          sx={{
            width: "100%",
            alignItems: "baseline",
            maxHeight: 300,
            height: "100%",
            overflow: "auto",
            position: "relative",
          }}
        />
      ) : (
        <Alert onClose={handleClose} severity={type} sx={{ width: "100%" }}>
          {message}
        </Alert>
      )}
    </Snackbar>
  );
});
